export const MAIL_LINK_FRAGMENT = "#m=";
